import React, { useContext } from "react";


function InterviewsPageLayout({ children }) {


    return (
        <div className="interviews-page-layout">
            {children}
        </div>
    )
}

export default InterviewsPageLayout;